module.exports = __webpack_public_path__ + "static/27cf3c3ed62f8756ffc8d19ec032fa774458e277d27ca1dd64a13197fce4141a-35b603c417e5e6dc45fd806ae9fb248a.jpeg";